<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Card Issuing</h2>

          </div>
          <div class="body mt-2 text-center">
            This module is currently not available

          </div>
        </div>
      </div>

    </div>



  </div>
</div>



